import React from 'react'

import { ErrorBoundary } from 'common/core/components/ErrorBoundary'

import { componentCache } from './componentCache'
import { SuspensePageProps } from './interfaces'
import { SuspensePageComponent } from './SuspensePageComponent'

export function SuspensePage(props: SuspensePageProps) {
  const CachedComponent = componentCache.get(props.importer)

  if (CachedComponent) {
    return (
      <ErrorBoundary scope="root" section="routing">
        <CachedComponent />
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary scope="root" section="routing">
      <SuspensePageComponent
        alias={props.alias}
        importer={props.importer}
        loadingFallback={props.loadingFallback}
      />
    </ErrorBoundary>
  )
}
